var non_private_browsing = true;
 
detectPrivateMode(function(is_private) {
  if (is_private) {
    non_private_browsing = false;
  } 
});

const getScreeHeight = () => {
    document.documentElement.style.setProperty('--mobile-header-height', document.querySelector("#header-wrap").clientHeight + "px");    
    document.documentElement.style.setProperty('--header-height', document.querySelector("#header-wrap").clientHeight + "px");    
    document.documentElement.style.setProperty('--screen-height', `${window.innerHeight}px`)
}
getScreeHeight()
window.addEventListener('resize', getScreeHeight, { passive: true })

jQuery(function($){
			
    doEmbroideryFees(); //updateCartStuff();
  
    doGiftWrapping();
    
	resizeWindow();
	
	scrollWindow();
	
 	$(window).resize(resizeWindow);
	
	$(window).scroll(scrollWindow);
	
	if ($('.nice').length) {
		$('.nice').niceSelect();
	}
  
    // promo bar
    $('#promo span.close').click(function() {
      $('#promo').fadeOut(300, function() {
         resizeWindow();
      });
      if(typeof(Storage) !== "undefined") {
        sessionStorage.hidePromoBar = 1;				
      }
    });
   	
	// mobile toggle
	$('#header .mobile_toggle').click(function() {
		if ($('#mobile_nav').hasClass('open')) {
			$('#mobile_nav, #header .mobile_toggle').removeClass('open');
			$('html,body').removeClass('locked');	
		} else {
			$('#mobile_nav, #header .mobile_toggle').addClass('open');
			$('html, body').animate({scrollTop: 0}, 'fast', function() {
				$('html,body').addClass('locked');	
			});
		}
	});
	
	// mobile subnavs
	$('#mobile_nav li.with_subnav').click(function() {
		var rel = $(this).attr('rel');
		$('#mobile_nav .subnav:not(.subnav-' + rel + ')').removeClass('open');
		$('#mobile_nav .subnav.subnav-' + rel).toggleClass('open');
	});

	// home: shop
	if ($('#home .shop .products .cycle-slideshow').length) {
		$('#home .shop .products .cycle-slideshow').on('cycle-before', function(e, opts) {
			$('#home .shop .images .cycle-slideshow').cycle('goto', opts.slideNum - 1);
		});
	}

	// inner scrollbars
	if ($('.scrollbar-inner').length) {
    	$('.scrollbar-inner').scrollbar();
	}
	
	// embroidery popup
	if ($('#embroidery_popup').length) {
		$('#embroidery .groups .group.styles .item').click(function() {
            var rel = $(this).attr('rel');
            $('#embroidery_popup .contents .table').hide(0);
            $('#embroidery_popup .contents .table.' + rel).show(0);
		    $('#embroidery_popup').fadeIn(300);
		});		
		$('#embroidery_popup .close').click(function() {
			$('#embroidery_popup').fadeOut(300);
		});	
	}
    if ($('#embroidery_popup_specialties').length) {
		$('#embroidery .groups .group.specialties .item').click(function() {
            var rel = $(this).attr('rel');
            $('#embroidery_popup_specialties .contents .table').hide(0);
            $('#embroidery_popup_specialties .contents .table.' + rel).show(0);
		    $('#embroidery_popup_specialties').fadeIn(300);
		});		
		$('#embroidery_popup_specialties .close').click(function() {
			$('#embroidery_popup_specialties').fadeOut(300);
		});	
	}
	
	// rewards faqs
	$('#rewards .faqs .faq .question').click(function() {
		$(this).toggleClass('open');
		$(this).next('.answer').slideToggle('fast');
	});
  
    // blog load more
    if (('#blog').length) {
        items = $('#blog .main .item').size();
        x = 3;
        $('#blog .main .loadmore a').click(function (e) {
            e.preventDefault();
            x = ( x + 3 <= items) ? x + 3 : items;
            $('#blog .main .item:lt(' + x + ')').show();
            if(x == items){
              	$('#blog .main .loadmore').hide();
            }
        });
    }
  
	
	// shop toggles
	$('#shop .shopnav .group .title.toggler').click(function() {
        $(this).toggleClass('open');
        $(this).next('.toggle').slideToggle('fast');
	});
    $('#shop .shopnav .group.group_vendor a').click(function(e) {
        e.preventDefault();
		var rel = $(this).attr('rel');
        $('#shop .shopnav .group.group_vendor a').removeClass('activelink');
        $(this).addClass('activelink');
        $('#shop .contents .inner .product_group').hide(0);
        $('#shop .contents .inner .product_group.' + rel).fadeIn(300);
    });
	
	// shop collapse toggles on mobile initially
	if ($('#shop .shopnav .group').length) {
		var ww = $(window).width();
		if (ww < 1024) {
			$('#shop .shopnav .group .title.toggler').removeClass('open');
			$('#shop .shopnav .group .toggle').hide(0);
		}
	}
  
    // back to top
    $('#backtotop').click(function() {
      $('html, body').animate({'scrollTop': 0}, 1000);
    });
	
	// product thumbs
	$('#product .main .images .thumbs span').click(function() {
		var rel = $(this).attr('rel');
		$('#product .main .images .thumbs span').removeClass('active');
		$(this).addClass('active');
		$('#product .main .images .inner img').attr('src', rel);
	});
	
	// product tabs
	$('#product .main .tabnav span').click(function(e) {
		var selected = $(this).attr('rel');
		$('#product .main .tabnav span').removeClass('active');
		$('#product .main .tabs .tab.selected').hide(0, function() {
		$(this).removeClass('selected');
			$('#product .main .tabs .tab.tab-' + selected).fadeIn(300).addClass('selected');
		});
		$(this).addClass('active');
	});
	
    // product selector dropdowns
    if ($('#product').length) {
      if ($('.selector-wrapper').length) {
        $('.selector-wrapper select').each(function() {
          $(this).niceSelect();
        });  
        $('.selector-wrapper').each(function() {
          var lbl = $(this).find('label').text();
          $(this).find('label').text('Select ' + lbl);
        });
        var count = $('.selector-wrapper').length;
        if (count > 1) {
          $('.selector-wrapper').each(function(i, el) {
            if (i % 2 === 0) { 
              $(el).wrap('<div class="floatleft"></div>');
            } else {
              $(el).wrap('<div class="floatright"></div>');
            }
          });
        } else {
          $('.selector-wrapper').css('margin-bottom','20px');
        }
      }
    }
  
	// cart
	$('.toggle_cart').click(function(e) {
		e.preventDefault();
		$('#header .mobile_toggle, #mobile_nav, #mobile_nav .subnav').removeClass('open');
		if ($('#cart').hasClass('open')) {
			$('#cart').removeClass('open');   
			$('#cart_overlay').fadeOut(300, function() {
				$('html,body').removeClass('locked');
			});
		} else { 
			$('#cart_overlay').fadeIn(300, function() {
				$('html,body').addClass('locked');
				$('#cart').addClass('open'); 
			});
		}
	});	 
  
    // newsletter
    $('#popup .close').click(function() {
      $('#popup').fadeOut(600, function() {
        if(typeof(Storage) !== "undefined") {
          if (non_private_browsing) {
            localStorage.peachesShowPopup = 1;
          }
        }  
      });    
    });
    if ($('#popup').length) {    
      if(typeof(Storage) !== "undefined") {
        if (non_private_browsing) {
          if (localStorage.peachesShowPopup != 1) {
            $('#popup').delay(3000).fadeIn(600);
          }
        }
      }
    }
	
});

function resizeWindow() {

	var ww = $(window).width();
	var wh = $(window).height();
	
    if ($('#sticky').length) {
        if (ww < 1200) {
            $('#sticky').hide(0);
        } else {
            $('#sticky').show(0); 
        }
    }
	  
    if (ww < 1024) {
        var hh = $('#header').outerHeight();
        var th = wh - hh;
        $('#mobile_nav').css({ 'top': hh + 'px', 'padding-bottom': hh + 'px' });
        $('#mobile_nav .subnav').css('height', th + 'px');
    }
  
    if ($('#promo').length) {
      $(window).load(function(){
        if(typeof(Storage) !== "undefined") {
          if (sessionStorage.hidePromoBar == 1) {
            // hide
          } else {
            // show
            $('#promo').show(0, function() {
               if (ww < 1024) {
                    var hh = $('#header').outerHeight();
                    var ph = $('#promo').outerHeight();
                    var hph = hh + ph;
                    var th = wh - hph; 
                }
                $('#mobile_nav').css({ 'top': hph + 'px', 'padding-bottom': hph + 'px' });
                $('#mobile_nav .subnav').css('height',th + 'px'); 
            });
          }
        } 
      });
    }
								 					
}

function scrollWindow() {
		
	var hh = $('#header').outerHeight();
	var ww = $(window).width();
		
	var scrolltop = $(window).scrollTop();
	
    if ($('#sticky').length) {
        if (scrolltop > 300) {
          $('#sticky').css('top','0');
        } else {
          $('#sticky').css('top','-100px');
        } 
    }
  
  	if ($('#backtotop').length) {
        if (scrolltop > 500) {
            $('#backtotop').fadeIn(300); 
        } else {
            $('#backtotop').fadeOut(300); 
        }
  	}
						
}

function addItem(form_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#' + form_id).serialize(),
      error: function(obj, status) { 
  	    alert('The product you are trying to add is out of stock.');
      }
   })
   .done(function() {
       doEmbroideryFees(); //updateCartStuff();
       doGiftWrapping();
       $('#cart_overlay').fadeIn(300, function() {
           $('html, body').addClass('frozen');
           $('#cart').addClass('open'); 
       });
   });
}

function cartSubtract(variant_id, qty) {
 
  var newQty = qty - 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function() {
      doEmbroideryFees(); //updateCartStuff();
      doGiftWrapping();   
      $('.update_cart').show();
  });
  
}

function cartAdd(variant_id, qty) {
 
  var newQty = qty + 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function() {
      doEmbroideryFees(); //updateCartStuff();
       doGiftWrapping();    
  });
  
}

function cartRemove(variant_id, el) {
  var removalAttributeArray = [];
  
  var ids = $(el).parent().attr('data-ids');
  var itemKey = $(el).parents('.item').attr('data-key');
  if(ids){
    var data = '';
    if(ids.includes(",")){
      ids.split(",").map(function(id){
        removalAttributeArray.push(id);
      })
    } else {
        removalAttributeArray.push(ids);    
    }   
    $.each(removalAttributeArray, function(key, value) {
      var emptyValue = "";
      if(key == 0){
        data += 'attributes[' + value + ']=' + emptyValue; 
      } else { 
        data += '&attributes[' + value + ']=' + emptyValue; 
      }
    });  
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json'
    })
    .done(function(variant_id) {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { quantity: 0, id: itemKey },
            dataType: 'json'
        })      
       doEmbroideryFees(); //updateCartStuff();
       doGiftWrapping();  
       giftNote = '';
      $('#gift_note').val('');    
    });    
    
  } else {
    var data = 'updates[' + variant_id + ']=0';    
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json'
    })
    .done(function(variant_id) {
       doEmbroideryFees(); //updateCartStuff();
       doGiftWrapping();  
       giftNote = '';
      $('#gift_note').val('');    
    });    
  }
  
//   console.log(removalAttributeArray)
  

  
}


function updateCartStuff() {
      
  $.ajax({
    
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
        
        var attributes = cart.attributes;
        
        
        $('#cart > .inner .cart_products').html('');
        
        $('#cart .subtotal .total_price').html((Shopify.formatMoney(cart.total_price)).replace('.00',''));

        if (cart.item_count > 0) {
          
          $.each(cart.items, function(index, cartItem) {

            
            var item = '';
           
              
            item += '<div class="item item-' + cartItem.product_title.substring(0,4).toLowerCase() + '" data-key="' + cartItem.key + '">';
                item += '<div class="table auto">';
                  item += '<div class="cell thumb">';
                  if (fee_handles.includes(cartItem.handle)) {
                    item += '<img src="' + cartItem.image + '" alt="" />';
                  } else {
                    item += '<a href="' + cartItem.url + '"><img src="' + cartItem.image + '" alt="" /></a>';
                  }
                  item += '</div>';
                  item += '<div class="cell">';
                    item += '<div class="details">';
                      item += '<span class="title">';
                        if(cartItem.product_title.includes("~")){
                          var updatedTitle = cartItem.product_title.split("~")
                          item += updatedTitle[0];                          
                        } else {
                          item += cartItem.product_title;                          
                        }
                        if (fee_handles.includes(cartItem.handle)) {
                            item += ' x ' + cartItem.quantity;
                        }
                      item += '</span>';
                      if (cartItem.variant_options.length > 0) {
                        $.each(cartItem.variant_options, function(i,o) {
                          if (o != 'Default Title' && !cartItem.options_with_values[i].name.includes('Gift Wrap')) {
                            item += '<span class="line_item gotham uppercase">' + cartItem.options_with_values[i].name + ': ' + o + '</span>';
                          }
                        });
                      }
                      if (cartItem.properties) {
                        $.each(cartItem.properties, function(i, o) {
                          if (o != '') {
                            if(cartItem.title.indexOf('Gift Wrapping') === -1){
                            item += '<span class="line_item gotham uppercase">' + i + ': ' + o + '</span>';
                             } else {
                             item += '<span class="line_item gotham uppercase">' + o + '</span>';
                            }
                          }
                        });
                      }
                      if (!fee_handles.includes(cartItem.handle)) {
                        item += '<div class="clearfix">';
                          item += '<div class="floatleft">';
                            if(!cartItem.product_title.includes("Gift Wrapping")){
                              item += '<span class="qty gotham_light">';
                                item += '<span class="minus" onClick="cartSubtract(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">–</span> <span class="amount">' + cartItem.quantity + '</span> <span class="plus" onClick="cartAdd(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">+</span>';
                              item += '</span>';                               
                             }
                          item += '</div>';
                          item += '<div class="floatright text-right">';
                            item += '<span class="price gotham_light">' + (Shopify.formatMoney(cartItem.price)).replace('.00','') + '</span>';
                          item += '</div>';
                        item += '</div>';
                        item += '<a href="#" class="remove" onClick="cartRemove(' + cartItem.variant_id  + ', this); return false;"></a>';
                      }
                    item += '</div>';
                  item += '</div>';
                item += '</div>';
              item += '</div>'; 
              
                                    
            $('#cart > .inner .cart_products').append(item);       

          });
          
          if($('#cart .cart_products .title').text().includes("Gift Wrapping")){
            $('#cart .inner .items .item .details span.minus, #cart .inner .items .item .details span.plus').css('visibility', 'hidden');
          }
          
          if($('.item-gift').length){
            $('#cart > .inner .cart_products .item:not(.item-gift)').find('.remove').hide();
            $('.item-gift').each(function(){
                var variantGiftWrappedProductLineItems = []
                var filteredArr = [];
                $(this).find('.line_item').each(function(){
                  var $this = $(this);
                  variantGiftWrappedProductLineItems.push($this.text())
                  if( $this.text().indexOf('_') >= 0) {
                      var text = $this.text().split('_')
                      $this.text(text[0])
                  }
                })
                filteredArr = variantGiftWrappedProductLineItems.filter(s => s.includes("_"));
                $(this).find('.details').attr('data-ids', filteredArr.toString());
            })
          }         
        
          $('#cart .bottom').show(0);
          
        } else {

          $('#cart .inner .cart_products').append('<div class="empty centertext">Your cart is empty.</div>');

          $('#cart .bottom').hide(0);
          
          var keys = Object.keys(attributes)
          var attributesRemovalObj = {}  
          $.each(keys, function(key, value) {     
            attributesRemovalObj[value] = "";
          });    
          $.ajax({
              type: 'POST',
              url: '/cart/update.js',
            data: {
              attributes: attributesRemovalObj
            },
              dataType: 'json'
          })          

        }
        
        $('#sticky .login a.cartlink span, #header .top .login a.cartlink span').html(cart.item_count);
  
     }
               
  });
  
  
  
}



/****************************************
            GIFT WRAPPING
****************************************/


//  EXAMPLE FOR CART ATTRIBUTES REMOVAL BY SETTING ATTRIBUTE
//	EQUAL TO AN EXMPTY STRING
// 	$.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//     data: {
//       attributes: {
//       "Jack Crabby Two-Piece Jammies | Size: 5Y_31522277097561:53b6535c871b318178cdd38ca71fc7f0": "",
//       "Jack Crabby Two-Piece Jammies | Size: 12-18M | Initials: BEC | Monogram Style: Theo_31522276933721:9a7ae93b94f3d4a37abc69ce594ab4a1": "",     
//       "Jack Crabby Two-Piece Jammies | Size: 12-18M | Initials: ppp | Monogram Style: Phoebe_31522276933721:6a28f574abdfb0cfb0dbf7f73af5f221": ""
//       }
//     },
//       dataType: 'json'
//   })




//EASY WAY TO REMOVE ITEMS IN AN ARRAY BY STRING
Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

//ARRAY DUPLICATE REMOVAL 
Array.prototype.unique =
  function() {
    var a = [];
    var l = this.length;
    for(var i=0; i<l; i++) {
      for(var j=i+1; j<l; j++) {
        // If this[i] is found later in the array
        if (this[i] === this[j])
          j = ++i;
      }
      a.push(this[i]);
    }
    return a;
  };

//ADD GIFT WRAPPING BUTTON CLICK FUNCTION
$('.add_gift_wrap').on('click', function(){
  $('#gift_wrapping').addClass('active');
  $('#gift_wrapping .cart_products .item input').prop('checked', false);
  giftNote = '';
  if(activeGiftWrappedProducts.length){
       $('.gift_wrapping_update button').removeClass('disabled');
       $('.gift_wrapping_update button').removeAttr('disabled');  
  } else {
       $('.gift_wrapping_update button').addClass('disabled');
       $('.gift_wrapping_update button.disabled').attr('disabled', true);      
  }  
})
$('.close_gift_wrapping').on('click', function(){
  $('#gift_wrapping').removeClass('active');
})

$('.return_to_cart').on('click',function(){
    $('#gift_wrapping').removeClass('active');
})

if(window.location.hash == '#cart') {
  $('html,body').addClass('locked');	
  $('#cart_overlay').show();
  $('#cart').addClass('open');
}

//INITIALIZES AN ARRAY THAT'LL BE USED TO ADD ATTRIBUTES TO IN THE CART.
//SETS GIFT NOTE STRING TO EMPTY
var activeGiftWrappedProducts = [];
var giftNote = '';

//GETS RANDOM INT TO ATTACH TO ITEM DATA ATTRIUBUTE 
//HELPS TO SOLVE WITH DUPLICATE TITLE IN GIFT PRODUCTS ISSUE
function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

//TOGGLE FUNCTION HANDLING SELECTING DIFFERENT PRODUCTS AND PLACING THEM WITH THE CORRECT GIFT PRODUCT
function toggleGiftWrapped (elem, num) {
  var title = $(elem).parents('.details').children('.title').attr('data-unique-title');
//   var randomInt = getRandomInt(99999)
  var price = parseInt($(elem).parents('.details').attr('data-qty'));
  if(price>1){
   	title += (title + ' ' + price + 'x' )
  }
  if ($(elem).is(':checked')) {
    activeGiftWrappedProducts.push(title + "~" + giftWrappingSelectedTitle);
  }
  else {
    activeGiftWrappedProducts.remove(title + "~" + giftWrappingSelectedTitle);
  }
  if(activeGiftWrappedProducts.length){
       $('.gift_wrapping_update button').removeClass('disabled');
       $('.gift_wrapping_update button').removeAttr('disabled');  
  } else {
       $('.gift_wrapping_update button').addClass('disabled');
       $('.gift_wrapping_update button.disabled').attr('disabled', true);      
  }
//   console.log('activeGiftWrapped: ' + activeGiftWrappedProducts)
}

//HANDLES GIFT WRAP NOTE ON CHANGE/TYPE/PASTE FUNCTION
if($('#gift_wrapping textarea').length){
  $('#gift_wrapping textarea').on('input propertychange', function(){
    giftNote = this.value;
  })
}  


//WORKS IN CONJUCTION WITH THE TOGGLE FUNCTION ABOVE TO ATTACH PRODUCTS TO GIFT PRODUCTS VIA ATTRIBUTES
//HANLDES CLICK FUNCTION TO ACTUALLY COMMIT THE PRODUCTS TO GIFT PRODUCT VIA ATTRIBUTES
if($("input[name='gift-wrapping']").length){
  
  var giftWrappingSelectedVariant = $("input[name='gift-wrapping']:checked").val();
  var giftWrappingSelectedTitle = $("input[name='gift-wrapping']:checked").attr('data-title');
  
  $("input[name='gift-wrapping']").on('change', function() {
      giftWrappingSelectedVariant = $(this).val();
      giftWrappingSelectedTitle = $(this).attr('data-title');
  });  
  
  $('.gift_wrapping_update button').on('click',function(){
    
    //loads up object with properties of the item's title that have been "checked"
    var props = {}  
    $.each(activeGiftWrappedProducts, function(key, value) {
      var updatedValue = value.split("~");
      var productTitle = updatedValue[0]
      var giftProductTitle = updatedValue[1]      
      props[productTitle] = value;
    });    

    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
      data: {
        attributes: props
      },
        dataType: 'json'
    }).done(function(){
      updateGiftWrappingProps(giftWrappingSelectedVariant)
    }) 

  })  
  
}


//ADDS IN THE NEW GIFT PRODUCT PROPS
function updateGiftWrappingProps(variant_id) {
  
  //loads up object with properties of the item's title that have been "checked"
  var props = {}  
  $.each(activeGiftWrappedProducts, function(key, value) {
      var updatedValue = value.split("~");
      var productTitle = updatedValue[0]
      var productTitleRemoveID = productTitle.split("_")
      var updatedProductTitle = productTitleRemoveID[0];
      var giftProductTitle = updatedValue[1]
      props[key] = productTitle;
  });    
  if(giftNote != ''){
    props[activeGiftWrappedProducts.length] = 'Message: ' + giftNote
  }
//   console.log(props)
  
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity:1,
        id:variant_id,
        properties: props
      },
      dataType: 'json'
  })
  .done(function() {
       doEmbroideryFees(); //updateCartStuff();
       doGiftWrapping();         
       $('#gift_wrapping').removeClass('active');
       giftNote = '';
        $('#gift_note').val('');
       $('.gift_wrapping_update button').addClass('disabled');
       $('.gift_wrapping_update button.disabled').attr('disabled', true);      
  });
  
}

//PULLS IN THE GIFT CART DATA AND SETS UP THE REST
function doGiftWrapping() {
  
  activeGiftWrappedProducts = [];

 
   $.ajax({
    
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
                
        $('#gift_wrapping .cart_products').html('')
        $('#gift_wrapping .heading_text').html('')
        $('#gift_wrapping .subheading span').html('')
        var attributes = Object.keys(cart.attributes)      
              

        if (cart.item_count > 0) {
          
          $.each(cart.items, function(index, cartItem) {
            
            
            var item = '';
            var gift_item_props = '';
            var key = cartItem.key;            
            
            //looks if product has already been added to a gift via props. if so the product is hidden so it can't be re-selected.
            var itemIsCurrentlyGiftWrapped = false;
            if(attributes.length){
              itemIsCurrentlyGiftWrapped = attributes.filter(s => s.includes(key));
            } else {
              var itemIsCurrentlyGiftWrapped = false
            }
            
            //shows all products in the cart in the gift wrapping area EXCEPT the actual gift wrapping product
            if(cartItem.title.indexOf('Gift Wrap') === -1 && cartItem.title.indexOf('Embroidery') === -1 && !itemIsCurrentlyGiftWrapped.length){
              //separates out each line item even with multiple quantities

                item += '<div class="item item-' + cartItem.variant_id + '">';
                  item += '<div class="table auto">';
                    item += '<div class="cell thumb">';
                    if (fee_handles.includes(cartItem.handle)) {
                      item += '<img src="' + cartItem.image + '" alt="" />';
                    } else {
                      item += '<a href="' + cartItem.url + '"><img src="' + cartItem.image + '" alt="" /></a>';
                    }
                    item += '</div>';
                    item += '<div class="cell">';
                      item += '<div class="details" data-qty="' + cartItem.quantity + '">';
                        if(cartItem.quantity > 1) {
                          
                          var monogramProperty1 = '';
                          var monogramProperty2 = '';
                          if (cartItem.properties) {
                            $.each(cartItem.properties, function(i, o) {
                              if(i == "Initials"){
                                monogramProperty1 = " | Initials: " + o + " | ";
                              } 
                              if(i == "Monogram Style"){
                                monogramProperty2 = "Monogram Style: " + o;
                              }
                            });
                          }                          

                         
                          if (cartItem.variant_options.length > 0) {
                            var option = '';
                            $.each(cartItem.variant_options, function(i,o) {
                              if (o != 'Default Title' && i == 0) {
                                option = " | " + cartItem.options_with_values[i].name + ': ' + o
                              }
                            });
                          } 
                          
                          
                        item += '<span class="title" data-unique-title="(' + cartItem.quantity + 'x) ' + cartItem.product_title + option + monogramProperty1 + monogramProperty2 +  "_" + key + '">';
                        item += cartItem.product_title + ' (' + cartItem.quantity + 'x)';                             
                          
                          
                        } else {
                          
                          
                          var monogramProperty1 = '';
                          var monogramProperty2 = '';
                          if (cartItem.properties) {
//                             console.log(cartItem.properties)
                            $.each(cartItem.properties, function(i, o) {
                              if(i == "Initials"){
                                monogramProperty1 = " | Initials: " + o + " | ";
                              } 
                              if(i == "Monogram Style"){
                                monogramProperty2 = "Monogram Style: " + o;
                              }
                            });
                          }                          

                         
                          if (cartItem.variant_options.length > 0) {
                            var option = '';
                            $.each(cartItem.variant_options, function(i,o) {
                              if (o != 'Default Title' && i == 0) {
                                option = " | " + cartItem.options_with_values[i].name + ': ' + o
                              }
                            });
                          }                          


                          item += '<span class="title" data-unique-title="' + cartItem.product_title + option + monogramProperty1 + monogramProperty2 + "_" + key + '">';       
                          item += cartItem.product_title;
                          
                          
                          
                        }
                          if (fee_handles.includes(cartItem.handle)) {
                              item += ' x ' + cartItem.quantity;
                          }
                        item += '</span>';
                        if (cartItem.variant_options.length > 0) {
                          $.each(cartItem.variant_options, function(i,o) {
                            if (o != 'Default Title') {
                              item += '<span class="line_item gotham uppercase">' + cartItem.options_with_values[i].name + ': ' + o + '</span>';
                            }
                          });
                        }
                        if (cartItem.properties) {
                          $.each(cartItem.properties, function(i, o) {
                            if (o != '') {
                              item += '<span class="line_item gotham uppercase">' + i + ': ' + o + '</span>';
                            }
                          });
                        }
                        if (!fee_handles.includes(cartItem.handle)) {
                          item += '<div class="gift_add_checkbox checkbox"><input type="checkbox" onClick="toggleGiftWrapped(this, ' +  cartItem.variant_id + ');"/><span class="checkmark"></span></div>';
                        }
                      item += '</div>';
                    item += '</div>';
                  item += '</div>';
                item += '</div>';                    

            }

            $('#cart #gift_wrapping .cart_products').append(item); 
                        
            
          });          
                 
        
          $('#cart .add_gift_wrap').show(0);
          
          if(attributes.length){
            $('#gift_wrapping .heading_text').append("Add Another Gift")
          } else {
             $('#gift_wrapping .heading_text').append("Wrap a Gift")
          }
          
                  
          if(!$('#gift_wrapping .cart_products .item').length){
            $('#gift_wrapping .subheading span').append("All of the items in your cart have been gift wrapped").css({
              'max-width': '350px',
              'margin': '50px auto',
              'line-height': '1.5'
            })
            $('#gift_wrapping .subheading > div').show()
            $('#gift_wrapping #cart_gift_item').hide();            
          } else {
            $('#gift_wrapping .subheading span').append("Select the item(s) you'd like to wrap together").css({
              'max-width': '100%',
              'margin': '0 auto',
              'line-height': '1.5'
            });
            $('#gift_wrapping .subheading > div').hide()
            $('#gift_wrapping #cart_gift_item').show();
             $('.gift_wrapping_update button').removeClass('disabled');
             $('.gift_wrapping_update button').removeAttr('disabled');               
          } 
          
        } else {

          $('#cart .add_gift_wrap').hide(0);

        }
          
     }
               
  });
 
 
}